var map = {
	"./asscher.png": 764,
	"./asscher@2x.png": 306,
	"./cushion.png": 765,
	"./cushion@2x.png": 307,
	"./emerald.png": 766,
	"./emerald@2x.png": 308,
	"./heart.png": 767,
	"./heart@2x.png": 309,
	"./marquise.png": 768,
	"./marquise@2x.png": 310,
	"./oval.png": 769,
	"./oval@2x.png": 311,
	"./pear.png": 770,
	"./pear@2x.png": 312,
	"./princess.png": 771,
	"./princess@2x.png": 313,
	"./radiant.png": 772,
	"./radiant@2x.png": 314,
	"./round.png": 773,
	"./round@2x.png": 315,
	"./trilliant.png": 774,
	"./trilliant@2x.png": 316
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;



//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images ^\.\/.*\.png$
// module id = 506
// module chunks = 0